import { render, staticRenderFns } from "./PDNProfileTable.vue?vue&type=template&id=d954b2f8&scoped=true&"
import script from "./PDNProfileTable.vue?vue&type=script&lang=js&"
export * from "./PDNProfileTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d954b2f8",
  null
  
)

export default component.exports